module.exports = __webpack_public_path__ + "img/brands-pan-stars-body.png?c61c37d444d170eff8ce44aa5690d933";